module.exports = __webpack_public_path__ + "img/swipe-left.d4cbc187.svg";